/* rw-footer.js — accordion-kolommen van het gedeelde footer-component (byte-identiek in beide thema's,
   bewaakt door tests/redesign/footer_mirror_spec.py). Onder het breakpoint (--rw-footer-bp uit rw-footer.css)
   worden de kolomkoppen togglebare knoppen met aria-expanded/aria-controls; daarboven zijn het gewone h2's.
   Zonder dit script klapt niets in (rw-footer.css hangt het inklappen aan html.js). */
(function () {
  var footer = document.querySelector('.rw-footer');
  if (!footer) return;
  var bp = (getComputedStyle(footer).getPropertyValue('--rw-footer-bp') || '700px').trim();
  var mq = window.matchMedia('(max-width: ' + bp + ')');
  var cols = Array.prototype.slice.call(footer.querySelectorAll('[data-rw-footcol]'));

  function apply(on) {
    cols.forEach(function (col) {
      var h = col.querySelector('[data-rw-footacc]'), nav = col.querySelector('.rw-footer__links');
      if (!h || !nav) return;
      /* W10-1e: de kop is nu een echte <button> (native rol/toetsenbord); desktop = disabled i.p.v. role-jongleren */
      if (on) {
        h.removeAttribute('disabled');
        h.setAttribute('aria-controls', nav.id);
        h.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
      } else {
        col.classList.remove('is-open');
        h.setAttribute('disabled', '');
        h.removeAttribute('aria-expanded'); h.removeAttribute('aria-controls');
      }
    });
  }
  function toggle(col) {
    var h = col.querySelector('[data-rw-footacc]');
    var open = col.classList.toggle('is-open');
    h.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  footer.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('[data-rw-footacc]');
    if (!h || !mq.matches) return;
    toggle(h.closest('[data-rw-footcol]'));
  });
  /* W10-1e: geen eigen Enter/Spatie-handler meer — de native <button> vuurt click, anders toggelde het dubbel */
  apply(mq.matches);
  var onChange = function (e) { apply(e.matches); };
  if (mq.addEventListener) { mq.addEventListener('change', onChange); } else if (mq.addListener) { mq.addListener(onChange); }
})();
